import {faker}  from "@faker-js/faker";
import { getOrgApp } from "../helpers/get-orgApp";
import { getSelectedDepartmentFromAccount } from "../helpers/get-accounts";
import { regions } from "./regions";

const regionCodes = regions.map((reg) => reg.RegionCode);

export const allVpcs = async (count, accountList, regionList) => {
  let vpcs = [];
  let orgAppDetails = await getOrgApp();
  let selectedDepartments = [];
  if (accountList && accountList.length > 0) {
    selectedDepartments = getSelectedDepartmentFromAccount(
      orgAppDetails,
      accountList
    );
  }
  for (var i = 0; i < count; i++) {
    let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
    let selectedDept = faker.helpers.arrayElement(
      selectedDepartments && selectedDepartments.length > 0
        ? selectedDepartments
        : selectedOrg.depts
    );
    let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);
    let selectedDeptAccount = faker.helpers.arrayElement(
      selectedDept.deptAccounts
    );

    let vpcId = "vpc-" + faker.random.alphaNumeric(8);

    if (i === 0) {
      vpcId = "vpc-1594696f"; // with subnets
    }

    const RegionCode =
      regionList && regionList.length
        ? faker.helpers.arrayElement(regionList)
        : faker.helpers.arrayElement(regionCodes);

    vpcs.push({
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      Tags: [],
      OrganizationId: selectedOrg.orgId,
      ResourceId: vpcId,
      ResourceName: faker.helpers.arrayElement([
        selectedDeptApp.appName + "-VPC",
        vpcId,
      ]),
      AccountNumber: selectedDeptAccount.accountNumber,
      ARN: `arn:aws::vpc:${RegionCode}:${faker.random.alphaNumeric(15)}`,
      RegionCode,
      State: "available",
      DepartmentId: selectedDept.deptId,
      UpdatedAt: null,
      OwnerId: null,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      CidrBlock: "172.31.0.0/16",
      IsDefault: 1,
      ResourceCount: i === 0 ? 22 : faker.number.int({ min: 0, max: 100 }),
    });
  }
  return vpcs;
};

const resourceTypes = [
  {
    ResourceType: "Instance",
    Count: 3,
  },
  {
    ResourceType: "AutoScalingGroup",
    Count: 3,
  },
  {
    ResourceType: "Subnet",
    Count: 6,
  },
  {
    ResourceType: "LoadBalancer",
    Count: 1,
  },
  {
    ResourceType: "ElasticIp",
    Count: 3,
  },
  {
    ResourceType: "Lambda",
    Count: 2,
  },
  {
    ResourceType: "DynamoDbTable",
    Count: 1,
  },
  {
    ResourceType: "Volume",
    Count: 3,
  },
];

export const vpcResources = (selectedVpc, resources) => {
  let vpcResources = [];
  resourceTypes.forEach((resourceType) => {
    let filteredResources = [];
    filteredResources = resources.filter(
      (el) =>
        el.ResourceType === resourceType.ResourceType &&
        el.AccountNumber === selectedVpc.AccountNumber
    );
    const selected = filteredResources.slice(0, resourceType.Count);
    selected.forEach((res) => {
      let resource = { ...res };
      resource.Region = selectedVpc.RegionCode;
      resource.ApplicationId = "default";
      resource.EnvironmentId = "default";
      vpcResources.push(resource);
    });
  });

  return vpcResources;
};
